var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinimizeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "rotate(90 12 12)",
    fill: "#111111",
    fillOpacity: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 9.99976V9H9V6.99976L9.99976 6.99976V9.99976H6ZM9 6L9.99976 6V6.99976L9 6.99976V6ZM9 17.0002H9.99976V18H9V17.0002ZM9.99976 14.0002V17.0002H9V15H6V14.0002H9.99976ZM14.0002 9.99976V6L15 6V9L18 9L18 9.99976H14.0002ZM18 14.0002L18 15H15L15 18H14.0002V14.0002H18Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinimizeIcon);
export default __webpack_public_path__ + "static/media/minimizeIcon.84fb382789f33f6297223202e9bb933f.svg";
export { ForwardRef as ReactComponent };